import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { IFilterContractsByLot } from '../../models/filters';
import {
  IContractLot,
  IGenericResult,
  IContractsInLot,
  ILot
} from '../../models/generic';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiLotDetailService {
  routeToDetailEvent = new Subject<{
    lotId: string;
    type: 'Manual' | 'Automatic';
  }>();

  /*baseUrlInvoicesLots = `${environment.apis.invoices.baseUrl}/${environment.apis.invoices.microservices.batch}`;*/
  baseUrlInvoicesLots = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.invoiceBatch}`;
  /*baseUrlTransferLots = `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.batch}`;*/
  baseUrlTransferLots = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferBatch}`;
  
  constructor(private _http: HttpClient) { }

  integrateLotInvoiceWithSap(lotId: string): Observable<IGenericResult<any>> {
    return this._http.post<IGenericResult<any>>(
      `${this.baseUrlInvoicesLots}/sap-integration/${lotId}`,
      {}
    );
  }

  clearBillIntegrationReSendSap(lotId: string): Observable<IGenericResult<any>> {
    return this._http.post<IGenericResult<any>>(
      `${this.baseUrlInvoicesLots}/bill-integration-resend/${lotId}`,
      {}
    );
  }

  refreshNFENumber(lotId: string): Observable<IGenericResult<any>> {
    return this._http.post<IGenericResult<any>>(
      `${this.baseUrlInvoicesLots}/batch/RefreshNFENumber/${lotId}`,
      {}
    );
  }

  integrateLotTransferWithSap(lotId: string): Observable<IGenericResult<any>> {
    return this._http.post<IGenericResult<any>>(
      `${this.baseUrlTransferLots}/sapintegration/${lotId}`,
      {}
    );
  }

  validationLotWithSap(lotId: string): Observable<IGenericResult<any>> {
    return this._http.post<IGenericResult<any>>(
      `${this.baseUrlInvoicesLots}/batch/BatchSapOk/${lotId}`,
      {}
    );
  }

  //cancelBatchInvoiceWithSap(lotId: string): Observable<IGenericResult<any>> {
  //  return this._http.post<IGenericResult<any>>(
  //    `${this.baseUrlInvoicesLots}/batch/CancelNFE/${lotId}`,
  //    {}
  //  );
  //}

  cancelBatchTransferWithSap(lotId: string): Observable<IGenericResult<any>> {
    return this._http.post<IGenericResult<any>>(
      `${this.baseUrlTransferLots}/${lotId}/cancel`,
      {}
    );
  }

  createPaymentDate(
    lotId: string,
    PaymentDate: {
      PaymentDate: string;
    }
  ): Observable<IGenericResult<unknown>> {
    return this._http.post<IGenericResult<unknown>>(
      `${this.baseUrlInvoicesLots}/batch/${lotId}/paymentdate`,
      PaymentDate
    );
  }

  updateCommentInvoice(lotId: string, Comment: { Comment: string; }): Observable<IGenericResult<unknown>> {
    return this._http.put<IGenericResult<unknown>>(
      `${this.baseUrlInvoicesLots}/batch/comment/${lotId}`,
      Comment
    );
  }

  updateCommentTransfer(lotId: string, Comment: { Comment: string; }): Observable<IGenericResult<unknown>> {
    return this._http.put<IGenericResult<unknown>>(
      `${this.baseUrlTransferLots}/batch/comment/${lotId}`,
      Comment
    );
  }
}
